import { CSSProperties } from 'react'

export const transactionTable: { [key: string]: CSSProperties } = {
  container: {
    width: '100%',
    fontSize: '1rem',
    wordWrap: 'break-word',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
  },
  th: {
    color: '#196FAB',
    fontWeight: 'bold',
    padding: '12px 10px',
    borderBottom: '1px solid #ddd',
    textAlign: 'left',
    fontSize: '1rem',
    wordWrap: 'break-word',
  },
  td: {
    padding: '12px 10px',
    borderBottom: '1px solid #ddd',
    verticalAlign: 'top',
    textAlign: 'left',
    wordWrap: 'break-word',
  },
  oddRow: {
    backgroundColor: '#F3F3F3',
  },
}

export const summaryTableColumnsStyles = {
  depositIdHeaderRender: { display: 'flex', justifyContent: 'flex-start', WordWrap: 'break-word' },
  depositIdCellRender: { color: '#0490C3', WordWrap: 'break-word' },
  dateCellRender: { justifyContent: 'flex-end', fontSize: '1rem', WordWrap: 'break-word' },
}

export const paymentCellStyle = {
  cellColorBlue: { color: '#0B99F1' },
}
